// compares 2 versions and check if it is a major or minor update ~ Kerry
export const versionCompare = (older, newer) => {
  if (!older || !newer) return false
  const current = String(older).padEnd(5, '.0').split('.')
  const latest = String(newer).padEnd(5, '.0').split('.')
  if (current[0] < latest[0]) {
    return 'major'
  } else if (current[1] < latest[1] || current[2] < latest[2]) {
    return 'minor'
  } else {
    return false
  }
}

export const getLatestVersion = (data, type) => {
  if (!data) return
  return data.find((latest) => latest.name.toLowerCase() === type).version
}
